import { render, staticRenderFns } from "./SuperTableCreate.vue?vue&type=template&id=03dac36f&scoped=true"
import script from "./SuperTableCreate.vue?vue&type=script&lang=js"
export * from "./SuperTableCreate.vue?vue&type=script&lang=js"
import style0 from "./SuperTableCreate.vue?vue&type=style&index=0&id=03dac36f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dac36f",
  null
  
)

export default component.exports